// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5510":"69987afe2f5fe7b5","8973":"66fb8d442a1af5a8"}[chunkId] + ".js";
};